import React, { ChangeEventHandler, MouseEvent, useRef } from 'react';
import { CameraOutlined } from '@ant-design/icons';
import { Button } from '../../Button/Button';
import { IMAGE_ACCEPT } from '../utils/checkFileIsImage';

export interface CaptureButtonProps {
  readonly text: string;
  onCapture: ChangeEventHandler<HTMLInputElement>;
}

export const CaptureButton: React.VFC<CaptureButtonProps> = ({ text, onCapture }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = (event: MouseEvent) => {
    event.stopPropagation();
    inputRef.current?.click();
  };

  return (
    <>
      <Button icon={<CameraOutlined />} onClick={handleButtonClick}>
        {text}
      </Button>
      <input
        ref={inputRef}
        accept={IMAGE_ACCEPT}
        capture="environment"
        style={{ display: 'none' }}
        type="file"
        onChange={onCapture}
        onClick={(event: MouseEvent) => {
          // we want to prevent propagation to the above Upload
          event.stopPropagation();
        }}
      />
    </>
  );
};
